import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import MultiTextInput from '../../../components/fields/MultiTextInput/MultiTextInput';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TravelHistoryDTO from '../../../dto/TravelHistoryDTO';
import { createClearObject } from '../../../utils/utils';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import DateTimeRangePicker from '../../../components/fields/RangeDatePicker/DateTimeRangePicker';
import MapInput from '../../../components/fields/MapInput/MapInput';

export function TravelHistoryFilter(props) {
  const {
    onHide, getValues, setValue, reset, defaultValues, meta = {
      total: 0,
    }, control,
  } = props;
  const { formatMessage } = useIntl();

  const clear = () => {
    const fields = getValues();
    const cleared = createClearObject(fields);
    reset({ ...cleared, ...defaultValues });
  };
  const save = () => {
    onHide();
  };
  const DTO = new TravelHistoryDTO();
  const attributes = DTO.getAttributesByName();
  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={save}
      open
    >
      <DialogTitle
        header={formatMessage({ id: 'filters' })}
        title={<Icons onClick={onHide} customIcon icon="close" className="close" />}
      />
      <DialogContent className="hff-content custom-scroll-theme">
        <form className="filter-content-wrapper">
          <FieldDTO
            control={control}
            component={DateTimeRangePicker}
            dtoObject={attributes.trip_started_at}
            variant="material"
            placeholder=""
            changeFormat="YYYY-MM-DDTHH:mm:ss"
            usePortal
            withLabel
          />
          <FieldDTO
            control={control}
            component={DateTimeRangePicker}
            dtoObject={attributes.trip_ended_at}
            variant="material"
            placeholder=""
            changeFormat="YYYY-MM-DDTHH:mm:ss"
            usePortal
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            component={MapInput}
            dtoObject={attributes.start_coordinate}
            variant="material"
            placeholder=""
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            component={MapInput}
            dtoObject={attributes.end_coordinate}
            variant="material"
            placeholder=""
            withLabel
          />
          <FieldDTOWithCol
            control={control}
            component={MapInput}
            dtoObject={attributes.middle_coordinate}
            variant="material"
            placeholder=""
            withLabel
          />
          <FieldDTO
            control={control}
            component={MultiTextInput}
            dtoObject={attributes.vehicle_registry_number}
            variant="material"
            placeholder=""
            withLabel
          />
          <FieldDTO
            control={control}
            component={MultiTextInput}
            dtoObject={attributes.carrier_registry_number}
            variant="material"
            placeholder=""
            withLabel
          />
          <Row>
            <FieldDTOWithCol
              control={control}
              component={TextInputWithLabel}
              dtoObject={attributes.trip_cost}
              variant="material"
              placeholder=""
              withLabel
            />
          </Row>
        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-text">{formatMessage({ id: 'find' })} {meta?.total || 0} автомобилей</div>
        <div className="hff-footer-buttons hff-center">
          <Button
            className="hff-clear-data"
            variant="secondary"
            onClick={clear}
          >{formatMessage({ id: 'clear.all' })}
          </Button>
          <Button className="hff-clear-show" onClick={save}>{formatMessage({ id: 'show' })}</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
